var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gc-grid-description-code-cell-template"},[_c('span',{staticClass:"gc-grid-description"},[_vm._v(_vm._s(_vm.description))]),_c('span',{staticClass:"gc-grid-code"},[_vm._v(_vm._s(_vm.code))])])
}
var staticRenderFns = []

export { render, staticRenderFns }